/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Shift_Event_ForwardInputs */



/**
* | output |
* | --- |
* | "Shift Event Forward" |
*
* @param {Shortcut_Keys_Name_Shift_Event_ForwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_shift_event_forward = /** @type {((inputs?: Shortcut_Keys_Name_Shift_Event_ForwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Shift_Event_ForwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler l'evenement vers l'avant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis vorwärts verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta evento in avanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сдвиг события вперед")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar evento hacia adelante")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向前移动事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを前へシフト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना को आगे बढ़ाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocar evento para a frente")
	return /** @type {LocalizedString} */ ("Shift Event Forward")
});